<template>
  <b-container>
    <b-card
      title="Change Your Password"
      class="col-lg-8 offset-lg-2 col-xl-4 offset-xl-4"
    >
      <b-form @submit.prevent="update">
        <b-form-group label="Old Password" label-class="font-weight-bold">
          <b-form-input
            type="password"
            v-model="oldPassword"
            :state="feedback.old_password ? !feedback.old_password : null"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.old_password"
            v-if="feedback.old_password"
          >
            {{ f }}
          </b-form-invalid-feedback>
          <router-link to="/accounts/password/reset/">Forget It?</router-link>
        </b-form-group>
        <b-form-group
          label="New Password"
          description="Password must be at least 8 characters long and contain at least 1 uppercase letter, 1 lowercase letter and 1 digit."
          label-class="font-weight-bold"
        >
          <b-form-input
            type="password"
            v-model="password"
            :state="feedback.password ? !feedback.password : null"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.password"
            v-if="feedback.password"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="New Password Confirmation"
          label-class="font-weight-bold"
        >
          <b-form-input
            type="password"
            v-model="passwordConfirmation"
            :state="password ? passwordConfirmation === password : null"
            required
            ref="passwordConfirmation"
          ></b-form-input>
          <b-form-invalid-feedback>
            비밀번호가 일치하지 않습니다.
          </b-form-invalid-feedback>
        </b-form-group>
        <div class="submit-button-group">
          <router-link to="/accounts/" class="btn btn-secondary mr-1"
            >Cancel</router-link
          >
          <b-button type="submit" variant="primary">Change Password</b-button>
        </div>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import Vue from "vue";
import { User } from "../models";

export default Vue.component("password", {
  data() {
    return {
      user: new User(window.user),
      feedback: {},
      oldPassword: "",
      password: "",
      passwordConfirmation: ""
    };
  },
  methods: {
    async update() {
      if (this.password !== this.passwordConfirmation) {
        this.$refs.passwordConfirmation.focus();
        return;
      }

      try {
        await this.user.changePassword({
          old_password: this.oldPassword,
          password: this.password
        });

        this.$router.push({
          name: "account"
        });
      } catch ({ response }) {
        if (response.status === 400) {
          this.feedback = response.data;
        }
      }
    }
  }
});
</script>
